import React, { FC, useState } from 'react';
import { Box, Container, Drawer, Grid, IconButton, Theme, withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { PageLink } from 'components/common/atoms';
import { BurgerMenuDark } from 'assets/svgs/nav';
import { LedMobileLogoIcon } from 'assets/svgs/led';
import { LedMenu } from 'containers/led/layouts';
import MobileAppLink from 'containers/common/sections/MobileAppLink';

const useStyles = makeStyles((theme: Theme) => ({
  topNav: {
    height: 63,
    backgroundColor: theme.palette.background.paper,
    boxShadow: 'none',
    width: '100%',
    display: 'block',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 0,
    zIndex: 1000,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  blockIcon: {
    marginRight: theme.spacing(-2),
    marginTop: theme.spacing(-0.6),
  },
  burgerIcon: {
    '&:hover': {
      backgroundColor: 'transparent ',
    },
  },
  root: {
    width: 287,
    height: '100vh',
    backgroundColor: theme.palette.background.paper,
  },
  logo: {
    padding: theme.spacing(4, 0, 12, 3),
  },
}));

const StyledContainer = withStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    padding: theme.spacing(3, 2.5),
  },
}))(Container);

const LedMobileNavigation: FC = () => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const toggleMenu = () => setOpen(!open);

  return (
    <>
      <MobileAppLink />
      <Grid className={classes.topNav}>
        <StyledContainer>
          <Grid container justifyContent="space-between">
            <Grid item>
              <PageLink href="/" aria-label={'Theme Logo'}>
                <LedMobileLogoIcon />
              </PageLink>
            </Grid>
            <Grid className={classes.blockIcon} item>
              <IconButton
                disableTouchRipple
                onClick={toggleMenu}
                color="inherit"
                aria-label="menu"
                className={classes.burgerIcon}
              >
                {open || <BurgerMenuDark />}
              </IconButton>
            </Grid>
          </Grid>
        </StyledContainer>
      </Grid>
      <Drawer anchor="left" open={open} onClose={toggleMenu}>
        <Box className={classes.root}>
          <Box className={classes.logo}>
            <PageLink href="/" aria-label={'Theme Logo'}>
              <LedMobileLogoIcon />
            </PageLink>
          </Box>
          <LedMenu />
        </Box>
      </Drawer>
    </>
  );
};

export default LedMobileNavigation;
